const {
  canAccessDocumentAnalyzer,
  canSeeDocumentAnalyzer,
} = require('./canAccessDocumentAnalyzer');
const hasFeatureFlag = require('./hasFeatureFlag');

/**
 * Check if the user can access the DA compare documents feature
 *
 * This feature is accessible for all DA users, but we separate the checks
 * in the case this would change.
 *
 * @param {Boolean} isExpired - true if the user is expired
 * @param {string} plan - user plan
 * @param {Array<string>} payingOptions - list of options for the user
 * @param {Boolean} isLoggedIn - true if the user is logged in
 */
const canAccessDocumentsComparison = (
  isExpired,
  plan,
  payingOptions,
  isLoggedIn,
) => {
  return canAccessDocumentAnalyzer(isExpired, plan, payingOptions, isLoggedIn);
};

/**
 * Check if the user can see the DA compare documents feature
 *
 * This feature is accessible for all DA users, but we separate the checks
 * in the case this would change.
 *
 * @param {string} plan - user plan
 * @param {Array<string>} payingOptions - list of options for the user
 * @param {Boolean} isLoggedIn - true if the user is logged in
 */
const canSeeDocumentsComparison = (plan, payingOptions, isLoggedIn) => {
  return canSeeDocumentAnalyzer(plan, payingOptions, isLoggedIn);
};

module.exports = {
  canAccessDocumentsComparison,
  canSeeDocumentsComparison,
};
